const SET_SELLING_ACCESS = 'app/sellingAccess/SET';
const initialState = { country: null };

export default function reducer(state = initialState, action = {}) {
  return action.type === SET_SELLING_ACCESS ? { country: action.payload.country || null } : state;
}

export const initializeSellingAccess = lookup => async dispatch => {
  let access = initialState;
  try {
    access = await lookup();
  } catch (error) {
    // Unknown locations cannot sell, independently of language preferences.
  }
  dispatch({ type: SET_SELLING_ACCESS, payload: access || initialState });
};
